import React, { useMemo } from 'react'
import { PageHeader } from 'functional-foundations'
import { EnrollmentType } from '../interface/EnrollmentType'
import { getValue } from 'firebase-utils'

interface PropsInterface {
    onClickBack?: () => unknown
    activePage: string
    currentTab: unknown
    brands: unknown[]
    campaigns: unknown[]
    campaignsWithNumber: unknown[]
}

/**
 *
 */
const Header = ({
    onClickBack,
    currentTab,
    activePage,
    brands,
    campaigns,
    campaignsWithNumber
}: PropsInterface): JSX.Element => {
    const showBackButton = useMemo(() => {
        if (activePage === 'create') {
            if (currentTab === EnrollmentType.Brand && brands.length) {
                return true
            }

            if (currentTab === EnrollmentType.Campaign && campaigns.length) {
                return true
            }

            if (currentTab === EnrollmentType.SmsNumber && campaignsWithNumber.length) {
                return true
            }
        }

        if (activePage === 'show') {
            return true
        }

        return false
    }, [currentTab, activePage, brands.length, campaigns.length, campaignsWithNumber.length])

    const text = useMemo(() => {
        if (showBackButton) {
            if (activePage === 'create') {
                if (currentTab === EnrollmentType.Brand) {
                    return getValue('sms_enrollment_add_brand_button')
                }
                if (currentTab === EnrollmentType.Campaign) {
                    return getValue('sms_enrollment_add_new_campaign')
                }
                if (currentTab === EnrollmentType.SmsNumber) {
                    return getValue('sms_enrollment_add_new_number')
                }
            }

            if (activePage === 'show') {
                return 'Review and Edit'
            }
        }
        return getValue('sms_registration_title')
    }, [showBackButton, activePage])
    return <PageHeader onClickBack={showBackButton ? onClickBack : undefined}>
        {text}
    </PageHeader>
}

export default Header
